import { render } from "./SkeletonLoader.vue?vue&type=template&id=c31c012a&scoped=true"
const script = {}

import "./SkeletonLoader.vue?vue&type=style&index=0&id=c31c012a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c31c012a"]])

export default __exports__